<template>
    <div>
        <a-modal
            :z-index="99999"
            v-model="active"
            title="Novo Tipo de Produto"
            :okText="step === 1 ? 'Próximo': $t('save')"
            okType="danger"
            :confirm-loading="loading"
            :cancelText="$t('cancel')"
            :wrapStyle="{ top: '-80px' }"
            @ok="save()"
        >
            <Stepper v-model="step" :steps="2"  style="overflow-y: hidden">
                <template slot="1">
                 <a-form :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }"
                    layout="vertical">
                    <a-form-item label="Tipo de produto" class="mb-2"
                        :validate-status="validationError && 'error' || ''"
                        :help="validationError && 'Preencha este campo' || ''"
                    >
                        <a-input placeholder="Entre com uma descrição para o tipo de produto"
                            v-model="description" 
                            @keydown.enter="save"/>
                    </a-form-item>
                    <a-form-item label="Detalhes" class="mb-2">
                        <a-textarea
                            placeholder="Informações gerais sobre a categoria. Ex.: 'Todos os pratos acompanham fritas'"
                            v-model="details" 
                            :auto-size="{ minRows: 2, maxRows: 5 }"
                            @keydown.enter="save"/>
                    </a-form-item>
                 </a-form>
                </template>
                 
                 <template slot="2" >
                    <vs-button type="flat" @click="step--" icon="keyboard_arrow_left" class="p-0">
                        Voltar
                    </vs-button>
                    <ExhibitionType v-model="simplified"/>
                 </template>
            </Stepper>
        </a-modal>
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import VxCard from '../vx-card/VxCard.vue';
    import Stepper from '../Stepper.vue';
    import ExhibitionType from './ExhibitionType.vue';
    export default {
        components: { VxCard, Stepper, ExhibitionType },
        props: {
            visible: Boolean,
            lastOrderNumber: Number,
            menuID : String,
            productType: Object
        },
        data() {
            return {
                loading: false,
                description: '',
                details: '',
                simplified: false,
                step: 1
            }
        },
        computed: {
            active: {
                get () { return this.visible; },
                set (v) {
                    if (!v)
                        this.reset();
                    this.$emit('update:visible', v); 
                },
            },
            validationError () { return this.description.length < 3; }
        },
        methods: {
            async save () {
                if (this.validationError)
                    return;
                if (this.step === 1) {
                    this.step++;
                    return;
                }
                this.loading = true;
                try {
                  let obj = {
                    description : this.description,
                    details: this.details,
                    menu: this.menuID,
                    showSimplified: this.simplified,
                  }
                  if (!this.productType) { // if is a new PT, set this default values
                    obj.active = true;
                    obj.order = this.lastOrderNumber || 0,
                    obj.products = {};
                    obj.fiscal = {}; // todo add a defalt fiscal data
                  }
                  const companyId = this.$store.getters.getCompanyID;
                  let ref = firebase.firestore().collection(`/company/${companyId}/productType`);
                  const id = this.productType && this.productType.id ? this.productType.id : undefined;

                  await ref.doc(id).set(obj, { merge : true });

                  this.$notification.success({
                      message: 'Sucesso!',
                      description: 'Tipo de produto salvo com sucesso!'
                  })

                  this.active = false;
                  this.reset();
                } catch (err) {
                  this.$error({
                      zIndex: 999999,
                      title: this.$t('error'),
                      content: `${this.$t('genericErrorMessage')}: ${err.message}`
                  })
                } finally {
                  this.loading = false
                }
            },
            reset () {
                this.step = 1;
                if (this.productType) {
                    this.description = this.productType.description;
                    this.details = this.productType.details || '';
                    this.simplified = this.productType.showSimplified || false;
                } else {
                    this.description = '';
                    this.details = '';
                    this.simplified = false;
                }
            }
        },
        mounted () {
            this.reset();
        }
    }
</script>

<style lang="scss" scoped>

</style>